import { CalculationResult } from "./CalculationResult";
import { CostData } from "./CostData";
import { FormulaRow } from "./FormulaRow";
import { Formulas } from "./Formulas";

export class Formatter
{
    static formatCostData(value: CostData): string
    {
        return `[${value.time} => ${[value.amount, value.unit].filter(v => v).join(" ")}]`;
    }
    static getResultName(value: boolean | null): string
    {
        if (value === true)
            return "Anomaly";
        if (value === false)
            return "Normal";
        return "Skipped";
    }
    static getResultDescription(value: boolean | null): string
    {
        if (value === true)
            return `Anomaly has been detected`;
        else if (value === false)
            return `It's a normal situation.`;
        return `The calculation has been skipped.`;
    }
    static getLogs(data: CostData[], value: CostData, formula: FormulaRow, result: CalculationResult): string[]
    {
        let definition = Formulas.getFormulaDefinition(formula.name);
        let ans: string[] = [Formatter.getResultDescription(result.value)];
        ans.push(`    ----------------------------`);
        if (result.reason)
            ans.push(`    Reason: ${result.reason}`);
        ans.push(`    Name: ${formula.name}`);
        ans.push(`    Data: [${data.map(d => Formatter.formatCostData(d)).join(", ")}]`);
        ans.push(`    Data Length: ${data.length}`);
        ans.push(`    Value: ${Formatter.formatCostData(value)}`);
        ans.push(`    Change Type: ${formula.change}`);
        ans.push(`    Formula: ${definition.formula}`);
        if (Object.keys(formula.parameters).length > 0)
        {
            ans.push(`    Arguments:`);
            ans.push(`        ------------------------`);
            Object.keys(formula.parameters).forEach(p =>
            {
                ans.push(`        ${p}: ${formula.parameters[p]}`);
            });
            ans.push(`        ------------------------`);
        }
        if (Object.keys(result.values).length > 0)
        {
            ans.push(`    Values:`);
            ans.push(`        ------------------------`);
            Object.keys(result.values).forEach(p =>
            {
                ans.push(`        ${p}: ${result.values[p]}`);
            });
            ans.push(`        ------------------------`);
        }
        ans.push(`    ----------------------------`);

        return ans;
    }
}